import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _addBookingsToMultiServiceBookingRequest = {};
var _addBookingsToMultiServiceBookingResponse = {
    bookings: '_bookingResult',
};
var _address = { geocode: '_addressLocation' };
var _addressLocation = {
    latitude: 'google.protobuf.DoubleValue',
    longitude: 'google.protobuf.DoubleValue',
};
var _bookingResult = { booking: '_v2Booking' };
var _bulkBookingResult = { item: '_v2Booking' };
var _bulkCalculateAllowedActionsRequest = {};
var _bulkCalculateAllowedActionsResponse = {};
var _bulkConfirmOrDeclineBookingRequest = {};
var _bulkConfirmOrDeclineBookingResponse = { results: '_bulkBookingResult' };
var _bulkCreateBookingRequest = { createBookingsInfo: '_createBookingInfo' };
var _bulkCreateBookingResponse = { results: '_bulkBookingResult' };
var _bulkGetMultiServiceBookingAllowedActionsRequest = {};
var _bulkGetMultiServiceBookingAllowedActionsResponse = {};
var _bulkRescheduleBookingRequest = {};
var _bulkRescheduleBookingResponse = {};
var _bulkUpdateBookedScheduleRequest = {};
var _bulkUpdateBookedScheduleResponse = {};
var _bulkUpdateBookingRequest = { bookings: '_maskedBooking' };
var _bulkUpdateBookingResponse = {};
var _cancelBookingAnonymouslyRequest = {};
var _cancelBookingAnonymouslyResponse = { booking: '_v2Booking' };
var _cancelBookingRequest = {};
var _cancelBookingResponse = { booking: '_v2Booking' };
var _cancelMultiServiceBookingRequest = {};
var _cancelMultiServiceBookingResponse = {
    multiServiceBooking: '_multiServiceBooking',
};
var _confirmBookingRequest = {};
var _confirmBookingResponse = { booking: '_v2Booking' };
var _confirmMultiServiceBookingRequest = {};
var _confirmMultiServiceBookingResponse = {
    multiServiceBooking: '_multiServiceBooking',
};
var _confirmOrDeclineBookingRequest = {};
var _confirmOrDeclineBookingResponse = { booking: '_v2Booking' };
var _consistentQueryBookingsRequest = {};
var _consistentQueryBookingsResponse = { bookings: '_v2Booking' };
var _countBookingsRequest = {};
var _countBookingsResponse = {};
var _createBookingInfo = { booking: '_v2Booking' };
var _createBookingRequest = { booking: '_v2Booking' };
var _createBookingResponse = { booking: '_v2Booking' };
var _createMultiServiceBookingRequest = { bookings: '_v2Booking' };
var _createMultiServiceBookingResponse = {
    multiServiceBooking: '_multiServiceBooking',
};
var _declineBookingRequest = {};
var _declineBookingResponse = { booking: '_v2Booking' };
var _declineMultiServiceBookingRequest = {};
var _declineMultiServiceBookingResponse = {
    multiServiceBooking: '_multiServiceBooking',
};
var _getAnonymousActionDetailsRequest = {};
var _getAnonymousActionDetailsResponse = {};
var _getBookingAnonymouslyRequest = {};
var _getBookingAnonymouslyResponse = { booking: '_v2Booking' };
var _getMultiServiceBookingAvailabilityRequest = {};
var _getMultiServiceBookingAvailabilityResponse = {};
var _getMultiServiceBookingRequest = {};
var _getMultiServiceBookingResponse = {
    multiServiceBooking: '_multiServiceBooking',
};
var _getScheduleAvailabilityRequest = {};
var _getScheduleAvailabilityResponse = {};
var _getSlotAvailabilityRequest = {};
var _getSlotAvailabilityResponse = {};
var _legacyCreateBookingRequest = { booking: '_v2Booking' };
var _legacyCreateBookingResponse = { booking: '_v2Booking' };
var _markBookingAsPendingRequest = {};
var _markBookingAsPendingResponse = { booking: '_v2Booking' };
var _markMultiServiceBookingAsPendingRequest = {};
var _markMultiServiceBookingAsPendingResponse = {
    multiServiceBooking: '_multiServiceBooking',
};
var _maskedBooking = {
    mask: 'google.protobuf.FieldMask',
    booking: '_v2Booking',
};
var _multiServiceBooking = { bookings: '_bookingResult' };
var _queryBookingsRequest = {};
var _queryBookingsResponse = { bookings: '_v2Booking' };
var _removeBookingsFromMultiServiceBookingRequest = {};
var _removeBookingsFromMultiServiceBookingResponse = {
    bookings: '_bookingResult',
};
var _rescheduleBookingAnonymouslyRequest = {};
var _rescheduleBookingAnonymouslyResponse = { booking: '_v2Booking' };
var _rescheduleBookingRequest = {};
var _rescheduleBookingResponse = { booking: '_v2Booking' };
var _rescheduleMultiServiceBookingRequest = {};
var _rescheduleMultiServiceBookingResponse = {
    multiServiceBooking: '_multiServiceBooking',
};
var _setBookingFormAndSubmissionIdRequest = {};
var _setBookingFormAndSubmissionIdResponse = { booking: '_v2Booking' };
var _setBookingSessionIdRequest = {};
var _setBookingSessionIdResponse = { booking: '_v2Booking' };
var _setBookingSubmissionIdRequest = {};
var _setBookingSubmissionIdResponse = { booking: '_v2Booking' };
var _updateBookingRequest = {
    mask: 'google.protobuf.FieldMask',
    booking: '_v2Booking',
};
var _updateBookingResponse = { booking: '_v2Booking' };
var _updateExtendedFieldsRequest = {};
var _updateExtendedFieldsResponse = {};
var _updateNumberOfParticipantsRequest = {};
var _updateNumberOfParticipantsResponse = { booking: '_v2Booking' };
var _v2Booking = {
    createdDate: 'google.protobuf.Timestamp',
    startDate: 'google.protobuf.Timestamp',
    endDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    canceledDate: 'google.protobuf.Timestamp',
    contactDetails: '_v2ContactDetails',
};
var _v2CancelBookingRequest = {};
var _v2CancelBookingResponse = { booking: '_v2Booking' };
var _v2ConfirmBookingRequest = {};
var _v2ConfirmBookingResponse = { booking: '_v2Booking' };
var _v2ContactDetails = { fullAddress: '_address' };
var _v2CreateBookingRequest = { contactDetails: '_v2ContactDetails' };
var _v2CreateBookingResponse = { booking: '_v2Booking' };
var _v2DeclineBookingRequest = {};
var _v2DeclineBookingResponse = { booking: '_v2Booking' };
var _v2RescheduleBookingRequest = {};
var _v2RescheduleBookingResponse = { booking: '_v2Booking' };
var _v2UpdateNumberOfParticipantsRequest = {};
var _v2UpdateNumberOfParticipantsResponse = { booking: '_v2Booking' };
function resolveComWixpressBookingsBookingsV2MultiServiceBookingsUrl(opts) {
    var domainToMappings = {
        _: [
            {
                srcPath: '/_api/bookings-service/v2/bookings',
                destPath: '/v2/bookings',
            },
            {
                srcPath: '/_api/bookings-service/v2/bulk/bookings',
                destPath: '/v2/bulk/bookings',
            },
            {
                srcPath: '/_api/bookings-service/v2/multi_service_bookings',
                destPath: '/v2/multi_service_bookings',
            },
            {
                srcPath: '/_api/bookings-service/v2/bulk/multi_service_bookings',
                destPath: '/v2/bulk/multi_service_bookings',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/bookings-service/v2/bookings',
                destPath: '/v2/bookings',
            },
            {
                srcPath: '/_api/bookings-service/v2/bulk/bookings',
                destPath: '/v2/bulk/bookings',
            },
            {
                srcPath: '/_api/bookings-service/v2/multi_service_bookings',
                destPath: '/v2/multi_service_bookings',
            },
            {
                srcPath: '/_api/bookings-service/v2/bulk/multi_service_bookings',
                destPath: '/v2/bulk/multi_service_bookings',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/_api/bookings-service/v2/bookings',
                destPath: '/v2/bookings',
            },
            {
                srcPath: '/bookings/v2/bookings',
                destPath: '/v2/bookings',
            },
            {
                srcPath: '/bookings/v2/bulk/bookings',
                destPath: '/v2/bulk/bookings',
            },
            {
                srcPath: '/_api/bookings-service/v2/multi_service_bookings',
                destPath: '/v2/multi_service_bookings',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/bookings-service/v2/bulk/bookings',
                destPath: '/v2/bulk/bookings',
            },
            {
                srcPath: '/_api/bookings-service/v2/bookings',
                destPath: '/v2/bookings',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/bookings-service/v2/bulk/bookings',
                destPath: '/v2/bulk/bookings',
            },
            {
                srcPath: '/_api/bookings-service/v2/bookings',
                destPath: '/v2/bookings',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/bookings-service/v2/bulk/bookings',
                destPath: '/v2/bulk/bookings',
            },
            {
                srcPath: '/_api/bookings-service/v2/bookings',
                destPath: '/v2/bookings',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_api/bookings-service/v2/bulk/bookings',
                destPath: '/v2/bulk/bookings',
            },
            {
                srcPath: '/_api/bookings-service/v2/bookings',
                destPath: '/v2/bookings',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/bookings-service',
                destPath: '/v2/bookings',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressBookingsBookingsV2BookingsUrl(opts) {
    var domainToMappings = {
        _: [
            {
                srcPath: '/_api/bookings-service/v2/bookings',
                destPath: '/v2/bookings',
            },
            {
                srcPath: '/_api/bookings-service/v2/bulk/bookings',
                destPath: '/v2/bulk/bookings',
            },
            {
                srcPath: '/_api/bookings-service/v2/multi_service_bookings',
                destPath: '/v2/multi_service_bookings',
            },
            {
                srcPath: '/_api/bookings-service/v2/bulk/multi_service_bookings',
                destPath: '/v2/bulk/multi_service_bookings',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/bookings-service/v2/bookings',
                destPath: '/v2/bookings',
            },
            {
                srcPath: '/_api/bookings-service/v2/bulk/bookings',
                destPath: '/v2/bulk/bookings',
            },
            {
                srcPath: '/_api/bookings-service/v2/multi_service_bookings',
                destPath: '/v2/multi_service_bookings',
            },
            {
                srcPath: '/_api/bookings-service/v2/bulk/multi_service_bookings',
                destPath: '/v2/bulk/multi_service_bookings',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/_api/bookings-service/v2/bookings',
                destPath: '/v2/bookings',
            },
            {
                srcPath: '/bookings/v2/bookings',
                destPath: '/v2/bookings',
            },
            {
                srcPath: '/bookings/v2/bulk/bookings',
                destPath: '/v2/bulk/bookings',
            },
            {
                srcPath: '/_api/bookings-service/v2/multi_service_bookings',
                destPath: '/v2/multi_service_bookings',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/bookings-service/v2/bulk/bookings',
                destPath: '/v2/bulk/bookings',
            },
            {
                srcPath: '/_api/bookings-service/v2/bookings',
                destPath: '/v2/bookings',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/bookings-service/v2/bulk/bookings',
                destPath: '/v2/bulk/bookings',
            },
            {
                srcPath: '/_api/bookings-service/v2/bookings',
                destPath: '/v2/bookings',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/bookings-service/v2/bulk/bookings',
                destPath: '/v2/bulk/bookings',
            },
            {
                srcPath: '/_api/bookings-service/v2/bookings',
                destPath: '/v2/bookings',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_api/bookings-service/v2/bulk/bookings',
                destPath: '/v2/bulk/bookings',
            },
            {
                srcPath: '/_api/bookings-service/v2/bookings',
                destPath: '/v2/bookings',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/bookings-service',
                destPath: '/v2/bookings',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressBookingsConfirmatorV2ConfirmatorUrl(opts) {
    var domainToMappings = {
        'www.wixapis.com': [
            {
                srcPath: '/_api/bookings-confirmator/v2/bookings/confirmation',
                destPath: '/v2/bookings/confirmation',
            },
            {
                srcPath: '/bookings/v2/confirmation',
                destPath: '/v2/confirmation',
            },
            {
                srcPath: '/bookings/v2/bulk/confirmation',
                destPath: '/v2/bulk/confirmation',
            },
            {
                srcPath: '/bookings/v2/bulk/bookings/confirmOrDecline',
                destPath: '/v2/bulk/bookings/confirmOrDecline',
            },
            {
                srcPath: '/_api/bookings-confirmator/v2/bulk/confirmation',
                destPath: '/v2/bulk/confirmation',
            },
            {
                srcPath: '/_api/bookings-confirmator/v2/bulk/bookings/confirmOrDecline',
                destPath: '/v2/bulk/bookings/confirmOrDecline',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressBookingsGatewayV2BookingsGatewayUrl(opts) {
    var domainToMappings = {
        _: [
            {
                srcPath: '/_api/bookings-gateway/v2/bookings',
                destPath: '/v2/bookings',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/bookings-gateway/v2/bookings',
                destPath: '/v2/bookings',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/_api/bookings-gateway/v2/bookings',
                destPath: '/v2/bookings',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/bookings-gateway/v2/bookings',
                destPath: '/v2/bookings',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveWixBookingsMigrationFormsV1SubmissionMigrationHelperUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/submission-migration-helper',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressBookingsBookingsV2AnonymousBookingActionsUrl(opts) {
    var domainToMappings = {
        _: [
            {
                srcPath: '/_api/bookings-service/v2/bookings',
                destPath: '/v2/bookings',
            },
            {
                srcPath: '/_api/bookings-service/v2/bulk/bookings',
                destPath: '/v2/bulk/bookings',
            },
            {
                srcPath: '/_api/bookings-service/v2/multi_service_bookings',
                destPath: '/v2/multi_service_bookings',
            },
            {
                srcPath: '/_api/bookings-service/v2/bulk/multi_service_bookings',
                destPath: '/v2/bulk/multi_service_bookings',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/bookings-service/v2/bookings',
                destPath: '/v2/bookings',
            },
            {
                srcPath: '/_api/bookings-service/v2/bulk/bookings',
                destPath: '/v2/bulk/bookings',
            },
            {
                srcPath: '/_api/bookings-service/v2/multi_service_bookings',
                destPath: '/v2/multi_service_bookings',
            },
            {
                srcPath: '/_api/bookings-service/v2/bulk/multi_service_bookings',
                destPath: '/v2/bulk/multi_service_bookings',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/_api/bookings-service/v2/bookings',
                destPath: '/v2/bookings',
            },
            {
                srcPath: '/bookings/v2/bookings',
                destPath: '/v2/bookings',
            },
            {
                srcPath: '/bookings/v2/bulk/bookings',
                destPath: '/v2/bulk/bookings',
            },
            {
                srcPath: '/_api/bookings-service/v2/multi_service_bookings',
                destPath: '/v2/multi_service_bookings',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/bookings-service/v2/bulk/bookings',
                destPath: '/v2/bulk/bookings',
            },
            {
                srcPath: '/_api/bookings-service/v2/bookings',
                destPath: '/v2/bookings',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/bookings-service/v2/bulk/bookings',
                destPath: '/v2/bulk/bookings',
            },
            {
                srcPath: '/_api/bookings-service/v2/bookings',
                destPath: '/v2/bookings',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/bookings-service/v2/bulk/bookings',
                destPath: '/v2/bulk/bookings',
            },
            {
                srcPath: '/_api/bookings-service/v2/bookings',
                destPath: '/v2/bookings',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_api/bookings-service/v2/bulk/bookings',
                destPath: '/v2/bulk/bookings',
            },
            {
                srcPath: '/_api/bookings-service/v2/bookings',
                destPath: '/v2/bookings',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/bookings-service',
                destPath: '/v2/bookings',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Returns booking details related to AnonymousActions
 * Anonymous tokens for getting, canceling or rescheduling the booking.
 * That token is symmetrically encrypted and Url-safe.
 * That allows the UoU to cancel or reschedule without Authentication.
 */
export function getAnonymousActionDetails(payload) {
    var _a = serializer(_getAnonymousActionDetailsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getAnonymousActionDetailsResponse, {}).fromJSON;
    function __getAnonymousActionDetails(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'GET',
            methodFqn: 'com.wixpress.bookings.bookings.v2.AnonymousBookingActions.GetAnonymousActionDetails',
            url: resolveComWixpressBookingsBookingsV2AnonymousBookingActionsUrl({
                protoPath: '/v2/bookings/anonymous-actions-details',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getAnonymousActionDetails.fromReq = fromReq;
    __getAnonymousActionDetails.__isAmbassador = true;
    return __getAnonymousActionDetails;
}
/** Cancel booking using an anonymous token */
export function cancelBookingAnonymously(payload) {
    var _a = serializer(_cancelBookingAnonymouslyRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_cancelBookingAnonymouslyResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _v2Booking: _v2Booking,
        _v2ContactDetails: _v2ContactDetails,
    }).fromJSON;
    function __cancelBookingAnonymously(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.bookings.v2.AnonymousBookingActions.CancelBookingAnonymously',
            url: resolveComWixpressBookingsBookingsV2AnonymousBookingActionsUrl({
                protoPath: '/v2/bookings/{token}/anonymous-cancel',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __cancelBookingAnonymously.fromReq = fromReq;
    __cancelBookingAnonymously.__isAmbassador = true;
    return __cancelBookingAnonymously;
}
/** Reschedule booking using an anonymous token */
export function rescheduleBookingAnonymously(payload) {
    var _a = serializer(_rescheduleBookingAnonymouslyRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_rescheduleBookingAnonymouslyResponse, { _address: _address, _addressLocation: _addressLocation, _v2Booking: _v2Booking, _v2ContactDetails: _v2ContactDetails }).fromJSON;
    function __rescheduleBookingAnonymously(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.bookings.v2.AnonymousBookingActions.RescheduleBookingAnonymously',
            url: resolveComWixpressBookingsBookingsV2AnonymousBookingActionsUrl({
                protoPath: '/v2/bookings/{token}/anonymous-reschedule',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __rescheduleBookingAnonymously.fromReq = fromReq;
    __rescheduleBookingAnonymously.__isAmbassador = true;
    return __rescheduleBookingAnonymously;
}
/** Get booking using an anonymous token */
export function getBookingAnonymously(payload) {
    var _a = serializer(_getBookingAnonymouslyRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getBookingAnonymouslyResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _v2Booking: _v2Booking,
        _v2ContactDetails: _v2ContactDetails,
    }).fromJSON;
    function __getBookingAnonymously(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'GET',
            methodFqn: 'com.wixpress.bookings.bookings.v2.AnonymousBookingActions.GetBookingAnonymously',
            url: resolveComWixpressBookingsBookingsV2AnonymousBookingActionsUrl({
                protoPath: '/v2/bookings/{token}/anonymous-get',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getBookingAnonymously.fromReq = fromReq;
    __getBookingAnonymously.__isAmbassador = true;
    return __getBookingAnonymously;
}
export function setBookingFormAndSubmissionId(payload) {
    var _a = serializer(_setBookingFormAndSubmissionIdRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_setBookingFormAndSubmissionIdResponse, { _address: _address, _addressLocation: _addressLocation, _v2Booking: _v2Booking, _v2ContactDetails: _v2ContactDetails }).fromJSON;
    function __setBookingFormAndSubmissionId(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'wix.bookings.migration.forms.v1.SubmissionMigrationHelper.SetBookingFormAndSubmissionId',
            url: resolveWixBookingsMigrationFormsV1SubmissionMigrationHelperUrl({
                protoPath: '/v2/bookings/{bookingId}/set-booking-form-and-submission-id',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __setBookingFormAndSubmissionId.fromReq = fromReq;
    __setBookingFormAndSubmissionId.__isAmbassador = true;
    return __setBookingFormAndSubmissionId;
}
/**
 * Creates a booking.
 *
 *
 * To create a booking for an appointment or a session of a class, pass the
 * relevant `slot` in the body of the request. You can use the
 * [Get Slot Availability](https://bo.wix.com/wix-docs/rest/bookings/availabilitycalendar---wip/get-slot-availability)
 * endpoint to check the availability of the session beforehand.
 *
 * To create a booking for the entire course, pass the relevant `schedule` in
 * the body of the request. You can use the
 * [Get Schedule Availability](https://bo.wix.com/wix-docs/rest/bookings/availabilitycalendar---wip/get-schedule-availability)
 * endpoint to check the availability of the course beforehand.
 *
 * Bookings are created with a status of `CREATED`. `CREATED` bookings don't
 * appear on the business calendar and don't affect a related schedule's
 * availability.
 *
 * If you create a booking for an existing session, we recommend that you
 * only pass `slot.sessionId`. Then, any specified slot details are
 * calculated.
 *
 * If you create a booking for a new session, we recommend to call
 * [Get Slot Availability](https://bo.wix.com/wix-docs/rest/bookings/availabilitycalendar---wip/get-slot-availability)
 * first. Then, pass the retrieved `availability.slot` object in the body of
 * the Create Booking request.
 *
 * If you create a booking for a course, we recommend that you pass only
 * `schedule.scheduleId` and not the entire `schedule` object. Then, all
 * schedule details are automatically calculated.
 *
 * When creating a booking you must pass either `participantsChoices` or
 * `totalParticipants`. If you pass `participantsChoices`, all of the
 * provided choices must exist for the service. Otherwise the call returns an
 * `INVALID_SERVICE_CHOICES` error.
 *
 * When creating a booking, you can pass a `selectedPaymentOption`. This specifies
 * which payment method the customer intends to use. But it's possible for
 * them to later use another supported payment method.
 *
 * After you have created the booking, you can use the
 * [Wix eCommerce APIs](https://bo.wix.com/wix-docs/rest/ecommerce/checkout/introduction)
 * for the [checkout](https://bo.wix.com/wix-docs/rest/ecommerce/checkout/create-checkout)
 * and [order](https://bo.wix.com/wix-docs/rest/ecommerce/checkout/create-order-from-checkout)
 * steps of the payment flow.
 * @deprecated
 */
export function bookingsGatewayCreateBooking(payload) {
    var _a = serializer(_v2CreateBookingRequest, { _address: _address, _addressLocation: _addressLocation, _v2ContactDetails: _v2ContactDetails }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_v2CreateBookingResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _v2Booking: _v2Booking,
        _v2ContactDetails: _v2ContactDetails,
    }).fromJSON;
    function __bookingsGatewayCreateBooking(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.gateway.v2.BookingsGateway.CreateBooking',
            url: resolveComWixpressBookingsGatewayV2BookingsGatewayUrl({
                protoPath: '/v2/bookings',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bookingsGatewayCreateBooking.fromReq = fromReq;
    __bookingsGatewayCreateBooking.__isAmbassador = true;
    return __bookingsGatewayCreateBooking;
}
/**
 * Cancels a booking.
 *
 *
 * The booking status changes to `CANCELED`.
 *
 * If the booking was for an appointment, the corresponding session is
 * deleted from the business calendar.
 *
 * If the booking was for a class or course, the participants are removed
 * from the class session or the course. But the course or class session
 * remain on the business calendar.
 *
 * You can pass a `participantNotification.message` to notify the customer of
 * the cancellation. You also need to pass `participantNotification.notifyParticipants`
 * as `true` to actually send the message.
 *
 * In case you want to cancel a booking on behalf of a customer, we recommend
 * to pass `flowControlSettings.ignoreCancellationPolicy` as `false`. This
 * ensures that the cancellation is validated against the service's cancellation
 * policy.
 * @deprecated
 */
export function cancelBooking(payload) {
    var _a = serializer(_cancelBookingRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_cancelBookingResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _v2Booking: _v2Booking,
        _v2ContactDetails: _v2ContactDetails,
    }).fromJSON;
    function __cancelBooking(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.gateway.v2.BookingsGateway.CancelBooking',
            url: resolveComWixpressBookingsGatewayV2BookingsGatewayUrl({
                protoPath: '/v2/bookings/{bookingId}/cancel',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __cancelBooking.fromReq = fromReq;
    __cancelBooking.__isAmbassador = true;
    return __cancelBooking;
}
/**
 * Reschedules a booking to a different slot or session.
 *
 *
 * You can only reschedule bookings for appointments or classes, you can't
 * reschedule course bookings.
 *
 * The old session is removed from the calendar and the new session is
 * added.
 *
 * If you reschedule a booking for a class session the new session must be an
 * existing session for the same class.
 *
 * You can pass a `participantNotification.message` to notify the customer of
 * the rescheduling. You also need to pass `participantNotification.notifyParticipants`
 * as `true` to actually send the message.
 *
 * In case the service has
 * [variants](https://dev.wix.com/api/rest/wix-bookings/service-options-and-variants/introduction),
 * you can call this endpoint to update the booking's `totalParticipants` or `participantsChoices`. If you
 * provide `participantsChoices`, all of the provided choices must exist for
 * the service. Otherwise the call returns an `INVALID_SERVICE_CHOICES` error.
 * If you omit `participantsChoices` in the request, the existing choices are
 * kept and not replaced with an empty object.
 *
 * <!-- INTERNAL PERMISSION COMMENT:
 * You need to have the `BOOKINGS.NUMBER_OF_PARTICIPANTS_UPDATE` permission
 * to reschedule bookings including `participantsInfo`.
 * <!--END: INTERNAL PERMISSION COMMENT-->
 *
 * In case you want to reschedule a booking on behalf of a customer, we recommend
 * to pass `flowControlSettings.ignoreReschedulePolicy` as `false`. This
 * ensures that the rescheduling is validated against the service's rescheduling
 * policy.
 * @deprecated
 */
export function bookingsGatewayRescheduleBooking(payload) {
    var _a = serializer(_v2RescheduleBookingRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_v2RescheduleBookingResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _v2Booking: _v2Booking,
        _v2ContactDetails: _v2ContactDetails,
    }).fromJSON;
    function __bookingsGatewayRescheduleBooking(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.gateway.v2.BookingsGateway.RescheduleBooking',
            url: resolveComWixpressBookingsGatewayV2BookingsGatewayUrl({
                protoPath: '/v2/bookings/{bookingId}/reschedule',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bookingsGatewayRescheduleBooking.fromReq = fromReq;
    __bookingsGatewayRescheduleBooking.__isAmbassador = true;
    return __bookingsGatewayRescheduleBooking;
}
/**
 * Confirms a booking request and changes the booking status to `CONFIRMED`.
 *
 *
 * Calling this endpoint doesn't check whether a slot or schedule is still
 * available at this time.
 *
 * You can only confirm bookings for services that require the owner's manual
 * approval for bookings and that have a status of `PENDING`. You can read more about
 * [creating a service](https://dev.wix.com/api/rest/wix-bookings/services/service/create-service).
 *
 * For appointment services the slot may become unavailable, depending on the
 * [service's](https://dev.wix.com/api/rest/wix-bookings/services/service/service-object)
 * `policy.bookingApprovalPolicy.requestsAffectsAvailability`.
 *
 * Calling this endpoint also changes the
 * [session's](https://dev.wix.com/api/rest/wix-bookings/schedules-and-sessions/session/get-session)
 * `participants.approvalStatus` to `APPROVED`.
 *
 * You can pass a `participantNotification.message` to notify the customer of
 * the confirmation. You also need to pass `participantNotification.notifyParticipants`
 * as `true` to actually send the message.
 *
 * Bookings are automatically confirmed when the
 * service is configured to [automatically confirm](https://dev.wix.com/api/rest/wix-bookings/services/service/create-service)
 * bookings and the [eCommerce order](https://bo.wix.com/wix-docs/rest/ecommerce/checkout/create-order-from-checkout)
 * has been approved. The slot's or schedule's availabity is checked just
 * before confirming the booking as part of the automatic flow.
 * @deprecated
 */
export function confirmBooking(payload) {
    var _a = serializer(_confirmBookingRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_confirmBookingResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _v2Booking: _v2Booking,
        _v2ContactDetails: _v2ContactDetails,
    }).fromJSON;
    function __confirmBooking(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.gateway.v2.BookingsGateway.ConfirmBooking',
            url: resolveComWixpressBookingsGatewayV2BookingsGatewayUrl({
                protoPath: '/v2/bookings/{bookingId}/confirm',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __confirmBooking.fromReq = fromReq;
    __confirmBooking.__isAmbassador = true;
    return __confirmBooking;
}
/**
 * Declines a `PENDING` booking request and changes the booking status to
 * `DECLINED`.
 *
 * Calling this endpoint also changes the
 * [session's](https://dev.wix.com/api/rest/wix-bookings/schedules-and-sessions/session/get-session)
 * `participants.approvalStatus` to `DECLINED`.
 *
 * You can only decline bookings for services that require the owner's manual
 * approval for bookings and that have a status of `PENDING`. You can read more about
 * [creating a service](https://dev.wix.com/api/rest/wix-bookings/services/service/create-service).
 *
 * You can pass a `participantNotification.message` to notify the customer of
 * the decline. You also need to pass `participantNotification.notifyParticipants`
 * as `true` to actually send the message.
 * @deprecated
 */
export function declineBooking(payload) {
    var _a = serializer(_declineBookingRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_declineBookingResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _v2Booking: _v2Booking,
        _v2ContactDetails: _v2ContactDetails,
    }).fromJSON;
    function __declineBooking(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.gateway.v2.BookingsGateway.DeclineBooking',
            url: resolveComWixpressBookingsGatewayV2BookingsGatewayUrl({
                protoPath: '/v2/bookings/{bookingId}/decline',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __declineBooking.fromReq = fromReq;
    __declineBooking.__isAmbassador = true;
    return __declineBooking;
}
/**
 * Updates the number of participants for a booking.
 *
 *
 * You can only update the number of participants for class and course
 * bookings, you can't update it for appointment bookings.
 *
 * Calling this endpoint also changes the
 * [session's](https://dev.wix.com/api/rest/wix-bookings/schedules-and-sessions/session/get-session)
 * `totalNumberOfParticipants`.
 *
 * When updating the number of participants for a booking you must pass either
 * `participantsChoices` or `totalParticipants`. If you pass `participantsChoices`
 * for services that have
 * [variants](https://dev.wix.com/api/rest/wix-bookings/service-options-and-variants/introduction),
 * all of the provided choices must exist for the service. Otherwise, the
 * call returns an `INVALID_SERVICE_CHOICES` error.
 * @deprecated
 */
export function updateNumberOfParticipants(payload) {
    var _a = serializer(_updateNumberOfParticipantsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateNumberOfParticipantsResponse, { _address: _address, _addressLocation: _addressLocation, _v2Booking: _v2Booking, _v2ContactDetails: _v2ContactDetails }).fromJSON;
    function __updateNumberOfParticipants(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.gateway.v2.BookingsGateway.UpdateNumberOfParticipants',
            url: resolveComWixpressBookingsGatewayV2BookingsGatewayUrl({
                protoPath: '/v2/bookings/{bookingId}/update_number_of_participants',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateNumberOfParticipants.fromReq = fromReq;
    __updateNumberOfParticipants.__isAmbassador = true;
    return __updateNumberOfParticipants;
}
/**
 * Updates the booking `status` to `CONFIRMED`, `PENDING`, or `DECLINED` based
 * on the `paymentStatus` you provide, double booking conflicts, and whether
 * the service requires business approval.
 *
 * ### eCommerce checkout restriction
 *
 * Call this method only when using a custom checkout page. Don't
 * call it when using a *Wix eCommerce checkout*
 * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/ecom/orders/setup) | [REST](https://dev.wix.com/docs/rest/business-solutions/e-commerce/checkout/introduction)).
 * In such cases, Wix automatically updates the booking status based on
 * the `paymentStatus` of the corresponding *Wix eCommerce order*
 * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/ecom/checkout/setup) | [REST](https://dev.wix.com/docs/rest/business-solutions/e-commerce/orders/introduction)).
 *
 * ### New booking status
 *
 * The booking `status` is set to `DECLINED` if both of the following conditions
 * are met:
 * + You provide `UNDEFINED`, `NOT_PAID`, `REFUNDED`, or `EXEMPT` as payment status.
 * + There is a double booking conflict.
 *
 * If only one or none of these conditions is met, `status` is set to `PENDING`
 * or `CONFIRMED` depending on whether the service requires business approval.
 *
 * ### Double bookings
 *
 * If there is a double booking conflict, but the booking has already been at least
 * partially paid, the method still marks the booking as `PENDING` or `CONFIRMED`.
 * Then, it also sets `doubleBooked` to `true`.
 *
 * ### Admin overwrites
 *
 * There are small but important differences in confirmation behavior if the
 * booking was created with special `flowControlSettings`:
 * + If the booking's `flowControlSettings.skipAvailabilityValidation` was set to
 * `true`, the booking is never declined regardless of double booking conflicts.
 * Instead, it's marked `CONFIRMED` or `PENDING`, depending on whether the
 * service requires business approval.
 * + If the booking's `flowControlSettings.skipBusinessConfirmation` was set to
 * `true`, the booking skips `PENDING` status and is marked `CONFIRMED`
 * immediately.
 */
export function confirmOrDeclineBooking(payload) {
    var _a = serializer(_confirmOrDeclineBookingRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_confirmOrDeclineBookingResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _v2Booking: _v2Booking,
        _v2ContactDetails: _v2ContactDetails,
    }).fromJSON;
    function __confirmOrDeclineBooking(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.confirmator.v2.Confirmator.ConfirmOrDeclineBooking',
            url: resolveComWixpressBookingsConfirmatorV2ConfirmatorUrl({
                protoPath: '/v2/confirmation/{bookingId}:confirmOrDecline',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __confirmOrDeclineBooking.fromReq = fromReq;
    __confirmOrDeclineBooking.__isAmbassador = true;
    return __confirmOrDeclineBooking;
}
/**
 * Confirms or declines up to 300 bookings.
 *
 *
 * See *Confirm Or Decline Booking*
 * ([SDK](https://dev.wix.com/docs/velo/api-reference/wix-bookings-v2/bookings/confirm-or-decline-booking) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/bookings/bookings-writer-v2/confirm-or-decline-booking))
 * for details about when a booking is confirmed or declined.
 */
export function bulkConfirmOrDeclineBooking(payload) {
    var _a = serializer(_bulkConfirmOrDeclineBookingRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkConfirmOrDeclineBookingResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _bulkBookingResult: _bulkBookingResult,
        _v2Booking: _v2Booking,
        _v2ContactDetails: _v2ContactDetails,
    }).fromJSON;
    function __bulkConfirmOrDeclineBooking(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.confirmator.v2.Confirmator.BulkConfirmOrDeclineBooking',
            url: resolveComWixpressBookingsConfirmatorV2ConfirmatorUrl({
                protoPath: '/v2/bulk/bookings/confirmOrDecline',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkConfirmOrDeclineBooking.fromReq = fromReq;
    __bulkConfirmOrDeclineBooking.__isAmbassador = true;
    return __bulkConfirmOrDeclineBooking;
}
/**
 * Creates a booking.
 *
 *
 * ### Appointment booking
 *
 * For appointment-based services, specify the relevant `slot` in
 * `bookedEntity.slot`. We recommend specifying the complete
 * `availabilityEntries.slot` returned in Query Availability
 * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/availability-calendar/query-availability) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/time-slots/availability-calendar/query-availability))
 * in your call's request to avoid failed calls due to unavailability.
 *
 * ### Class session booking
 *
 * For class services, specify the relevant event ID
 * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/calendar/events/introduction) | [REST](https://dev.wix.com/docs/rest/business-management/calendar/events-v3/introduction))
 * as `bookedEntity.slot.eventId`.
 * We recommend retrieving the event ID from Query Availability's
 * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/availability-calendar/query-availability) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/time-slots/availability-calendar/query-availability))
 * `availabilityEntries.slot.eventId` to avoid failed calls due to unavailability.
 * Specifying an event ID leads to automatic calculations of `slot.startDate`, `slot.endDate`,
 * `slot.timezone`, `slot.resource`, and `slot.location`. All manually specified
 * values are overridden.
 *
 * ### Course booking
 *
 * For course services, specify the course's schedule ID in `bookedEntity.schedule.scheduleId`.
 * We recommend following [this sample flow](https://dev.wix.com/docs/rest/business-solutions/bookings/end-to-end-booking-flows#book-a-course)
 * to minimize failed calls due to unavailability.
 *
 * ### Booking status
 *
 * Create Booking defaults to `status=CREATED`. Such bookings aren't visible in the [Booking Calendar](https://support.wix.com/en/article/wix-bookings-about-the-wix-booking-calendar).
 *
 * Only [identities](https://dev.wix.com/docs/build-apps/develop-your-app/access/about-identities) with `Manage Bookings` permissions can set `status=CONFIRMED`.
 *
 * ### Related resources
 *
 * Specifying a `resource` triggers an availability check, and the Create Booking call fails if the resource is unavailable.
 *
 * If you omit `resource`, resource assignment and availability validation occur during booking confirmation.
 * If no resources are available, the behavior depends on the confirmation method used and payment status.
 *
 * ### Participant information
 *
 * You must specify either `participantsChoices` or `totalParticipants`.
 * The call fails if the specified `participantsChoices` aren't among the supported
 * _service options and variants_
 * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/service-options-and-variants/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/service-options-and-variants/introduction)).
 *
 * ### Notify customers
 *
 * You can specify a `participantNotification.message` for the customer that's send
 * immediately. Ensure `participantNotification.notifyParticipants` is set to `true`
 * to send the message.
 *
 * If you specify `{"sendSmsReminder": true}`, the customer receives an SMS 24 hours
 * before the session starts. The phone number is taken from `contactDetails.phone`.
 *
 * ### Payment options
 *
 * The specified `selectedPaymentOption` indicates how the customer intends to pay, allowing for later changes to a different method supported by the service.
 *
 * ### Payment status
 *
 * All bookings are created with `paymentStatus=UNDEFINED`, ignoring the payment status you specify.
 *
 * For customers paying with a Wix eCommerce checkout ([SDK](https://dev.wix.com/docs/sdk/backend-modules/ecom/checkout/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/e-commerce/purchase-flow/checkout/checkout/introduction)), Wix Bookings automatically syncs the booking's payment status from the corresponding eCommerce order ([SDK](https://dev.wix.com/docs/sdk/backend-modules/ecom/orders/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/e-commerce/orders/introduction)).
 *
 * For customers using a custom checkout, call Confirm or Decline Booking ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/bookings/confirm-or-decline-booking) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/bookings/bookings-writer-v2/confirm-or-decline-booking)) to update booking's payment status manually.
 *
 * ### Booking form data
 *
 * When customers sign up for a service, they must fill out the booking form.
 * To create a booking with a completed booking form, specify the relevant data in
 * `formSubmission`. Ensure the values of the corresponding fields in
 * `booking.contactDetails` and `formSubmission` are identical. If these values
 * don't match, Create Booking fails. Therefore, we recommend specifying
 * only `booking.contactDetails.contactId` when providing `formSubmission`.
 *
 * ### Admin overwrites
 *
 * There are small but important differences when you specify special
 * `flowControlSettings`:
 *
 * - `{"skipAvailabilityValidation": true}`: The call succeeds
 * regardless of availability. If you don't specify any resource, the call
 * succeeds even if no resource of the relevant type is available.
 * - `{"skipBusinessConfirmation": true}`: Automatically confirms `PENDING`
 * bookings that require manual confirmation.
 * - `{"skipSelectedPaymentOptionValidation": true}`: Allows customers to pay
 * with payment methods that aren't supported for the service.
 *
 * When using special `flowControlSettings`, ensure you have sufficient
 * permissions. If you encounter failed calls due to insufficient permissions,
 * consider the following options:
 *
 * - **App developers** can use a higher
 * [permission](https://dev.wix.com/docs/build-apps/develop-your-app/access/authorization/about-permissions),
 * such as `MANAGE BOOKINGS - ALL PERMISSIONS`.
 * - **Site developers** can utilize
 * [elevation](https://dev.wix.com/docs/develop-websites/articles/coding-with-velo/authorization/elevation).
 *
 * Granting additional permissions and using elevation permits method calls that
 * would typically fail due to authorization checks. Therefore, you should use
 * them intentionally and securely.
 */
export function createBooking(payload) {
    var _a = serializer(_createBookingRequest, { _address: _address, _addressLocation: _addressLocation, _v2Booking: _v2Booking, _v2ContactDetails: _v2ContactDetails }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createBookingResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _v2Booking: _v2Booking,
        _v2ContactDetails: _v2ContactDetails,
    }).fromJSON;
    function __createBooking(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.bookings.v2.Bookings.CreateBooking',
            url: resolveComWixpressBookingsBookingsV2BookingsUrl({
                protoPath: '/v2/bookings',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createBooking.fromReq = fromReq;
    __createBooking.__isAmbassador = true;
    return __createBooking;
}
/**
 * Updates a booking.
 *
 *
 * You can't update `bookedEntity.item`, call Reschedule Booking instead.
 *
 * The call fails if the specified `participantsChoices` aren't among the supported
 * service options and variants.
 * @deprecated
 */
export function updateBooking(payload) {
    var _a = serializer(_updateBookingRequest, { _address: _address, _addressLocation: _addressLocation, _v2Booking: _v2Booking, _v2ContactDetails: _v2ContactDetails }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateBookingResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _v2Booking: _v2Booking,
        _v2ContactDetails: _v2ContactDetails,
    }).fromJSON;
    function __updateBooking(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'PATCH',
            methodFqn: 'com.wixpress.bookings.bookings.v2.Bookings.UpdateBooking',
            url: resolveComWixpressBookingsBookingsV2BookingsUrl({
                protoPath: '/v2/bookings/{booking.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateBooking.fromReq = fromReq;
    __updateBooking.__isAmbassador = true;
    return __updateBooking;
}
export function legacyCreateBooking(payload) {
    var _a = serializer(_legacyCreateBookingRequest, { _address: _address, _addressLocation: _addressLocation, _v2Booking: _v2Booking, _v2ContactDetails: _v2ContactDetails }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_legacyCreateBookingResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _v2Booking: _v2Booking,
        _v2ContactDetails: _v2ContactDetails,
    }).fromJSON;
    function __legacyCreateBooking(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.bookings.v2.Bookings.LegacyCreateBooking',
            url: resolveComWixpressBookingsBookingsV2BookingsUrl({
                protoPath: '/v2/bookings/createBooking',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __legacyCreateBooking.fromReq = fromReq;
    __legacyCreateBooking.__isAmbassador = true;
    return __legacyCreateBooking;
}
/**
 * Updates multiple bookings in bulk.
 *
 *
 * You can't update `bookedEntity.item`, call Reschedule Booking instead.
 *
 * The call fails if the specified `participantsChoices` aren't among the supported
 * service options and variants.
 */
export function bulkUpdateBooking(payload) {
    var _a = serializer(_bulkUpdateBookingRequest, {
        _address: _address,
        _addressLocation: _addressLocation,
        _maskedBooking: _maskedBooking,
        _v2Booking: _v2Booking,
        _v2ContactDetails: _v2ContactDetails,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateBookingResponse, {}).fromJSON;
    function __bulkUpdateBooking(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'PATCH',
            methodFqn: 'com.wixpress.bookings.bookings.v2.Bookings.BulkUpdateBooking',
            url: resolveComWixpressBookingsBookingsV2BookingsUrl({
                protoPath: '/v2/bookings/bulk/update',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateBooking.fromReq = fromReq;
    __bulkUpdateBooking.__isAmbassador = true;
    return __bulkUpdateBooking;
}
/**
 * Creates up to 8 bookings.
 *
 *
 * See Create Booking
 * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/bookings/create-booking) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/bookings/bookings-writer-v2/create-booking))
 * for more information.
 *
 * If any of the specified bookings is missing a required field the entire call
 * fails.
 *
 * If you specify 1 or more unavailable bookings, the call succeeds
 * while the unavailable bookings aren't created. Instead, they're counted as
 * failures in the returned `bulkActionMetadata`.
 */
export function bulkCreateBooking(payload) {
    var _a = serializer(_bulkCreateBookingRequest, {
        _address: _address,
        _addressLocation: _addressLocation,
        _createBookingInfo: _createBookingInfo,
        _v2Booking: _v2Booking,
        _v2ContactDetails: _v2ContactDetails,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkCreateBookingResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _bulkBookingResult: _bulkBookingResult,
        _v2Booking: _v2Booking,
        _v2ContactDetails: _v2ContactDetails,
    }).fromJSON;
    function __bulkCreateBooking(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.bookings.v2.Bookings.BulkCreateBooking',
            url: resolveComWixpressBookingsBookingsV2BookingsUrl({
                protoPath: '/v2/bulk/bookings/create',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkCreateBooking.fromReq = fromReq;
    __bulkCreateBooking.__isAmbassador = true;
    return __bulkCreateBooking;
}
/**
 * Reschedules an appointment booking to a different slot or a class booking to
 * a different session.
 *
 *
 * ### Course booking limitation
 *
 * You can't reschedule course bookings.
 *
 * ### Appointment sessions
 *
 * For appointments, the old session is removed from the business calendar
 * while a new session is added. We recommend calling Query Availability
 * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/availability-calendar/query-availability) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/time-slots/availability-calendar/query-availability))
 * first and specifying the entire retrieved `slot`.
 *
 * ### Class sessions
 *
 * For classes, the new session must be an existing session belonging to the
 * same class. We recommend retrieving `availabilityEntries.slot.eventId`
 * from Query Availability
 * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/availability-calendar/query-availability) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/time-slots/availability-calendar/query-availability))
 * to avoid failed Reschedule Booking calls due to unavailability. Specify
 * only `slot.eventId` instead of the entire `slot` object.
 *
 * ### Notify customers
 *
 * You can specify a `participantNotification.message` for the customer. To send
 * the message, you must also specify `participantNotification.notifyParticipants`
 * as `true`.
 *
 * ### Admin overwrites
 *
 * There are small but important differences when you specify special
 * `flowControlSettings`:
 *
 * - `{"ignoreReschedulePolicy": true}`: The call succeeds even if the
 * service's `reschedulePolicy` doesn't allow it.
 * - `{"skipAvailabilityValidation": true}`: The call succeeds even if
 * the specified session, slot, or resource isn't available. If you don't
 * specify any resource, the call succeeds even if no resource of the relevant
 * type is available.
 * - `{"skipBusinessConfirmation": true}`: Any `PENDING` booking is
 * automatically confirmed even if the services requires the merchants's
 * manual confirmation.
 *
 * When using special `flowControlSettings`, ensure you have sufficient
 * permissions. If you encounter failed calls due to insufficient permissions,
 * consider the following options:
 *
 * - **App developers** can use a higher
 * [permission](https://dev.wix.com/docs/build-apps/develop-your-app/access/authorization/about-permissions),
 * such as `MANAGE BOOKINGS - ALL PERMISSIONS`.
 * - **Site developers** can utilize
 * [elevation](https://dev.wix.com/docs/develop-websites/articles/coding-with-velo/authorization/elevation).
 *
 * Granting additional permissions and using elevation permits method calls that
 * would typically fail due to authorization checks. Therefore, you should use
 * them intentionally and securely.
 */
export function rescheduleBooking(payload) {
    var _a = serializer(_rescheduleBookingRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_rescheduleBookingResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _v2Booking: _v2Booking,
        _v2ContactDetails: _v2ContactDetails,
    }).fromJSON;
    function __rescheduleBooking(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.bookings.v2.Bookings.RescheduleBooking',
            url: resolveComWixpressBookingsBookingsV2BookingsUrl({
                protoPath: '/v2/bookings/{bookingId}/reschedule',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __rescheduleBooking.fromReq = fromReq;
    __rescheduleBooking.__isAmbassador = true;
    return __rescheduleBooking;
}
/**
 * Reschedules multiple bookings in bulk.
 *
 *
 * See Reschedule Booking
 * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/bookings/reschedule-booking) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/bookings/bookings-writer-v2/reschedule-booking))
 * for more information.
 *
 * If any of the specified bookings is missing a required field, the entire call
 * fails.
 *
 * If you specify 1 or more unavailable bookings, the call succeeds
 * while the unavailable bookings aren't created. Instead, they're counted as
 * failures in the returned `bulkActionMetadata`.
 */
export function bulkRescheduleBooking(payload) {
    var _a = serializer(_bulkRescheduleBookingRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkRescheduleBookingResponse, {}).fromJSON;
    function __bulkRescheduleBooking(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.bookings.v2.Bookings.BulkRescheduleBooking',
            url: resolveComWixpressBookingsBookingsV2BookingsUrl({
                protoPath: '/v2/bookings/bulk/reschedule',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkRescheduleBooking.fromReq = fromReq;
    __bulkRescheduleBooking.__isAmbassador = true;
    return __bulkRescheduleBooking;
}
export function bulkUpdateBookedSchedule(payload) {
    var _a = serializer(_bulkUpdateBookedScheduleRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateBookedScheduleResponse, {}).fromJSON;
    function __bulkUpdateBookedSchedule(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.bookings.v2.Bookings.BulkUpdateBookedSchedule',
            url: resolveComWixpressBookingsBookingsV2BookingsUrl({
                protoPath: '/v2/bookings/bulk/update_booked_schedule',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateBookedSchedule.fromReq = fromReq;
    __bulkUpdateBookedSchedule.__isAmbassador = true;
    return __bulkUpdateBookedSchedule;
}
export function query(payload) {
    var _a = serializer(_queryBookingsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryBookingsResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _v2Booking: _v2Booking,
        _v2ContactDetails: _v2ContactDetails,
    }).fromJSON;
    function __query(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.bookings.v2.Bookings.Query',
            url: resolveComWixpressBookingsBookingsV2BookingsUrl({
                protoPath: '/v2/bookings/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __query.fromReq = fromReq;
    __query.__isAmbassador = true;
    return __query;
}
/**
 * Updates the booking status to `CONFIRMED` without checking whether the relevant slot or schedule is still available.
 *
 *
 * ### eCommerce checkout restriction
 *
 * Call this method only when using a custom checkout page. Don't
 * call it when using a Wix eCommerce checkout
 * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/ecom/orders/setup) | [REST](https://dev.wix.com/docs/rest/business-solutions/e-commerce/checkout/introduction)).
 * In such cases, Wix automatically updates the booking status based on
 * the `paymentStatus` of the corresponding Wix eCommerce order
 * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/ecom/checkout/setup) | [REST](https://dev.wix.com/docs/rest/business-solutions/e-commerce/orders/introduction)).
 *
 * ### When to call Confirm Or Decline Booking instead
 *
 * Confirm Booking doesn't check whether a slot or schedule is still available.
 * For these checks, call Confirm or Decline Booking ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/bookings/confirm-or-decline-booking) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/bookings/bookings-writer-v2/confirm-or-decline-booking)) instead.
 *
 * ### Original status validation
 *
 * You can only confirm bookings with a status of `PENDING`, `CREATED`, or
 * `WAITING_LIST`.
 *
 * ### Double bookings
 *
 * Confirm Booking doesn't check whether a slot or schedule is still available.
 * You can specify
 *
 * ```json
 * {
 * "flowControlSettings": {
 * "checkAvailabilityValidation": true
 * },
 * "doubleBooked": true
 * }
 * ```
 * to forcefully set the booking's `doubleBooked` flag to `true`, regardless of
 * a potential double booking conflict. You must call with `Manage Bookings`
 * permissions to do so. For the default flow control settings
 * `{"checkAvailabilityValidation": false}`, the specified `doubleBooked` value
 * is ignored.
 *
 * ### Payment status
 *
 * Also updates the booking's `paymentStatus`, if you specify a new payment
 * status.
 *
 * ### Notify customers
 *
 * You can specify a `participantNotification.message` for the customer. To send
 * the message, you must also specify `participantNotification.notifyParticipants`
 * as `true`.
 */
export function bookingsConfirmBooking(payload) {
    var _a = serializer(_v2ConfirmBookingRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_v2ConfirmBookingResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _v2Booking: _v2Booking,
        _v2ContactDetails: _v2ContactDetails,
    }).fromJSON;
    function __bookingsConfirmBooking(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.bookings.v2.Bookings.ConfirmBooking',
            url: resolveComWixpressBookingsBookingsV2BookingsUrl({
                protoPath: '/v2/bookings/{bookingId}/confirm',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bookingsConfirmBooking.fromReq = fromReq;
    __bookingsConfirmBooking.__isAmbassador = true;
    return __bookingsConfirmBooking;
}
/** Private API, similar to Query, with consistent database connection. */
export function consistentQuery(payload) {
    var _a = serializer(_consistentQueryBookingsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_consistentQueryBookingsResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _v2Booking: _v2Booking,
        _v2ContactDetails: _v2ContactDetails,
    }).fromJSON;
    function __consistentQuery(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.bookings.v2.Bookings.ConsistentQuery',
            url: resolveComWixpressBookingsBookingsV2BookingsUrl({
                protoPath: '/v2/bookings/consistent_query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __consistentQuery.fromReq = fromReq;
    __consistentQuery.__isAmbassador = true;
    return __consistentQuery;
}
/** Private API, dedicated to setting `sessionId` for a booking after the session is created. */
export function setBookingSessionId(payload) {
    var _a = serializer(_setBookingSessionIdRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_setBookingSessionIdResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _v2Booking: _v2Booking,
        _v2ContactDetails: _v2ContactDetails,
    }).fromJSON;
    function __setBookingSessionId(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.bookings.v2.Bookings.SetBookingSessionId',
            url: resolveComWixpressBookingsBookingsV2BookingsUrl({
                protoPath: '/v2/bookings/{id}/set_booking_session_id',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __setBookingSessionId.fromReq = fromReq;
    __setBookingSessionId.__isAmbassador = true;
    return __setBookingSessionId;
}
/** Setting `submission_id` for a booking after the form submission is created. */
export function setBookingSubmissionId(payload) {
    var _a = serializer(_setBookingSubmissionIdRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_setBookingSubmissionIdResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _v2Booking: _v2Booking,
        _v2ContactDetails: _v2ContactDetails,
    }).fromJSON;
    function __setBookingSubmissionId(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.bookings.v2.Bookings.SetBookingSubmissionId',
            url: resolveComWixpressBookingsBookingsV2BookingsUrl({
                protoPath: '/v2/bookings/{bookingId}/set-booking-submission-id',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __setBookingSubmissionId.fromReq = fromReq;
    __setBookingSubmissionId.__isAmbassador = true;
    return __setBookingSubmissionId;
}
/**
 * Updates the extended fields for a booking.
 *
 *
 * If you specify an extended field `namespace` that doesn't exist yet, it's
 * created.
 *
 * Learn more about [extended fields](https://dev.wix.com/docs/build-apps/develop-your-app/extensions/backend-extensions/about-backend-extensions#schema-plugin-extensions).
 */
export function updateExtendedFields(payload) {
    var _a = serializer(_updateExtendedFieldsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateExtendedFieldsResponse, {}).fromJSON;
    function __updateExtendedFields(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.bookings.v2.Bookings.UpdateExtendedFields',
            url: resolveComWixpressBookingsBookingsV2BookingsUrl({
                protoPath: '/v2/bookings/{id}/update_extended_fields',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateExtendedFields.fromReq = fromReq;
    __updateExtendedFields.__isAmbassador = true;
    return __updateExtendedFields;
}
/**
 * Updates the booking status to `DECLINED` and updates the relevant session's
 * `participants.approvalStatus` to `DECLINED` without checking whether the relevant
 * slot or schedule is still available.
 *
 *
 * ### eCommerce checkout restriction
 *
 * Call this method only when using a custom checkout page. Don't
 * call it when using a Wix eCommerce checkout
 * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/ecom/orders/setup) | [REST](https://dev.wix.com/docs/rest/business-solutions/e-commerce/checkout/introduction)).
 * In such cases, Wix automatically updates the booking status based on
 * the `paymentStatus` of the corresponding Wix eCommerce order
 * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/ecom/checkout/setup) | [REST](https://dev.wix.com/docs/rest/business-solutions/e-commerce/orders/introduction)).
 *
 * ### When to call Confirm Or Decline Booking instead
 *
 * The method doesn't check whether a slot or schedule is still available. For
 * these checks you can call Confirm or Decline Booking
 * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/bookings/confirm-or-decline-booking) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/bookings/bookings-writer-v2/confirm-or-decline-booking)).
 *
 * ### Original status validation
 *
 * You can only decline bookings with a `status` of `PENDING`, `CREATED`, or
 * `WAITING_LIST`.
 *
 * ### Payment status
 *
 * Also updates the booking's `paymentStatus`, if you specify a new payment
 * status.
 *
 * ### Notify customers
 *
 * You can specify a `participantNotification.message` for the customer. To send
 * the message, you must also specify `participantNotification.notifyParticipants`
 * as `true`.
 */
export function bookingsDeclineBooking(payload) {
    var _a = serializer(_v2DeclineBookingRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_v2DeclineBookingResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _v2Booking: _v2Booking,
        _v2ContactDetails: _v2ContactDetails,
    }).fromJSON;
    function __bookingsDeclineBooking(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.bookings.v2.Bookings.DeclineBooking',
            url: resolveComWixpressBookingsBookingsV2BookingsUrl({
                protoPath: '/v2/bookings/{bookingId}/decline',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bookingsDeclineBooking.fromReq = fromReq;
    __bookingsDeclineBooking.__isAmbassador = true;
    return __bookingsDeclineBooking;
}
/**
 * Updates the booking status to `CANCELED`.
 *
 *
 * ### Appointments
 *
 * For appointments, the corresponding event is removed from the Bookings
 * calendar.
 *
 * ### Class and course bookings
 *
 * For class or course bookings, the relevant participants are removed
 * from the class session or the course. However, the class session or course
 * remain on the business calendar.
 *
 * ### Notify customers
 *
 * You can specify a `participantNotification.message` for the customer. To send
 * the message, you must also specify `participantNotification.notifyParticipants`
 * as `true`.
 *
 * ### Admin overwrites
 *
 * There are small but important differences when you specify special
 * `flowControlSettings`:
 *
 * - `{"ignoreCancellationPolicy": true}`: The call succeeds even if the
 * service's `cancellationPolicy` doesn't allow it.
 * - `{"withRefund": true}`: The customer is refunded even if the service's
 * `refundPolicy` doesn't allow it.
 * - `{"waiveCancellationFee": true}`: The customer doesn't have to pay
 * the cancellation fee, even if the service's `cancellationPolicy` requires it.
 *
 * When using special `flowControlSettings`, ensure you have sufficient
 * permissions. If you encounter failed calls due to insufficient permissions,
 * consider the following options:
 *
 * - **App developers** can use a higher
 * [permission](https://dev.wix.com/docs/build-apps/develop-your-app/access/authorization/about-permissions),
 * such as `MANAGE BOOKINGS - ALL PERMISSIONS`.
 * - **Site developers** can utilize
 * [elevation](https://dev.wix.com/docs/develop-websites/articles/coding-with-velo/authorization/elevation).
 *
 * Granting additional permissions and using elevation permits method calls that
 * would typically fail due to authorization checks. Therefore, you should use
 * them intentionally and securely.
 */
export function bookingsCancelBooking(payload) {
    var _a = serializer(_v2CancelBookingRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_v2CancelBookingResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _v2Booking: _v2Booking,
        _v2ContactDetails: _v2ContactDetails,
    }).fromJSON;
    function __bookingsCancelBooking(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.bookings.v2.Bookings.CancelBooking',
            url: resolveComWixpressBookingsBookingsV2BookingsUrl({
                protoPath: '/v2/bookings/{bookingId}/cancel',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bookingsCancelBooking.fromReq = fromReq;
    __bookingsCancelBooking.__isAmbassador = true;
    return __bookingsCancelBooking;
}
/**
 * Updates the number of participants for a class or course booking and changes
 * the `totalNumberOfParticipants` for the relevant sessions.
 *
 *
 * ### Appointment limitation
 *
 * You can't update the number of participants for appointment bookings.
 *
 * ### Participant information
 *
 * You must specify either `participantsChoices` or `totalParticipants`.
 * The call fails if the specified `participantsChoices` aren't among the
 * supported service options and variants
 * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/service-options-and-variants/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/service-options-and-variants/introduction)).
 */
export function bookingsUpdateNumberOfParticipants(payload) {
    var _a = serializer(_v2UpdateNumberOfParticipantsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_v2UpdateNumberOfParticipantsResponse, { _address: _address, _addressLocation: _addressLocation, _v2Booking: _v2Booking, _v2ContactDetails: _v2ContactDetails }).fromJSON;
    function __bookingsUpdateNumberOfParticipants(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.bookings.v2.Bookings.UpdateNumberOfParticipants',
            url: resolveComWixpressBookingsBookingsV2BookingsUrl({
                protoPath: '/v2/bookings/{bookingId}/update_number_of_participants',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bookingsUpdateNumberOfParticipants.fromReq = fromReq;
    __bookingsUpdateNumberOfParticipants.__isAmbassador = true;
    return __bookingsUpdateNumberOfParticipants;
}
/** Calculates the allowed actions for a given list of booking id's */
export function bulkCalculateAllowedActions(payload) {
    var _a = serializer(_bulkCalculateAllowedActionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkCalculateAllowedActionsResponse, {}).fromJSON;
    function __bulkCalculateAllowedActions(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.bookings.v2.Bookings.BulkCalculateAllowedActions',
            url: resolveComWixpressBookingsBookingsV2BookingsUrl({
                protoPath: '/v2/bulk/bookings/calculate_allowed_actions',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkCalculateAllowedActions.fromReq = fromReq;
    __bulkCalculateAllowedActions.__isAmbassador = true;
    return __bulkCalculateAllowedActions;
}
/**
 * Returns the availability for a given slot.
 *
 *
 * A slot for an appointment does not have a `sessionId`. Only a slot for a class has a `sessionId`.
 *
 *
 * Availability for an appointment is calculated as follows:
 * The following fields are required to get the availability for an appointment:
 * - `startDate`
 * - `endDate`
 * - `serviceId`
 * - `resourceId`
 * - `scheduleId`
 * 1- Calls Availability Calendar to:
 * - Check for available slots in the calendar.
 * - Check for booking policy violations in the services catalog.
 * 2-
 * - Checking for existing bookings with overlapping time, service & resource, where the booked session has transparency set to `"BUSY"`. When the booking is in the process of being checked out, it may not have a `sessionId` yet. In this case, it is considered as `"BUSY"`.
 *
 *
 * Availability for classes is calculated as follows:
 * For a class, the following fields are required:
 * - `sessionId`
 * 1- Calls Availability Calendar to:
 * - Check for total spots by the session's capacity.
 * - Check for booking policy violations in the services catalog.
 * - Check for the waiting list and its occupancy in the waiting list.
 * - Check for locked spots in the locks.
 * 2-
 * - Checking for open spots by subtracting the current number of participants from the total spots.
 */
export function getSlotAvailability(payload) {
    var _a = serializer(_getSlotAvailabilityRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getSlotAvailabilityResponse, {}).fromJSON;
    function __getSlotAvailability(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.bookings.v2.Bookings.GetSlotAvailability',
            url: resolveComWixpressBookingsBookingsV2BookingsUrl({
                protoPath: '/v2/bookings/get_slot_availability',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getSlotAvailability.fromReq = fromReq;
    __getSlotAvailability.__isAmbassador = true;
    return __getSlotAvailability;
}
/**
 * Returns availability for a given schedule ID.
 *
 * Availability for a course is calculated by:
 * - Checking for total spots based on the schedule's capacity.
 * - Checking for open spots by subtracting the current number of participants from the total spots.
 */
export function getScheduleAvailability(payload) {
    var _a = serializer(_getScheduleAvailabilityRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getScheduleAvailabilityResponse, {}).fromJSON;
    function __getScheduleAvailability(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'GET',
            methodFqn: 'com.wixpress.bookings.bookings.v2.Bookings.GetScheduleAvailability',
            url: resolveComWixpressBookingsBookingsV2BookingsUrl({
                protoPath: '/v2/bookings/{scheduleId}/get_schedule_availability',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getScheduleAvailability.fromReq = fromReq;
    __getScheduleAvailability.__isAmbassador = true;
    return __getScheduleAvailability;
}
/**
 * Updates the booking status to `PENDING`.
 *
 *
 * ### Service requirement
 *
 * By default, this method only works for services ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/services/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/introduction)) with `service.onlineBooking.requireManualApproval` set to `true`.
 * If you attempt to mark a booking as pending for a service that doesn't require approval, the call fails unless you use the `skipPendingApprovalServiceValidation` admin overwrite.
 *
 * ### Status requirements
 *
 * - __Original status__: Booking must have `CREATED` status.
 * - __Target status__: Booking moves to `PENDING`.
 *
 * ### Checkout restrictions
 *
 * Only call this method if the customer paid via a custom checkout. For Wix eCommerce checkouts ([SDK](https://dev.wix.com/docs/sdk/backend-modules/ecom/checkout/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/e-commerce/purchase-flow/checkout/introduction)), Wix Bookings automatically manages the bookings' statuses based on payment processing.
 *
 * When using custom checkouts, you can also update the booking's `paymentStatus` by specifying a new payment status.
 *
 * ### Business workflow
 *
 * After marking a booking as `PENDING`, the business must manually approve or reject it. You can call these methods:
 * - Confirm Booking ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/bookings/confirm-booking) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/bookings/bookings-writer-v2/confirm-booking)).
 * - Decline Booking ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/bookings/decline-booking) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/bookings/bookings-writer-v2/decline-booking)).
 *
 * ### Resource availability and scheduling
 *
 * Marking a booking as `PENDING` immediately affects resource availability:
 *
 * - **Calendar impact**: The booking appears on the business calendar.
 * - **Availability**: The time slot becomes unavailable for other bookings, even while pending approval.
 * - **Resource assignment**: Available resources ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/resources/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/resources/resources-v2/introduction)) are automatically assigned if none were explicitly selected during booking creation.
 *
 * ### Double bookings
 *
 * By default, the method doesn't check for availability conflicts. To detect and handle double bookings, use the `checkAvailabilityValidation: true` admin overwrite.
 *
 * ### Notify customers
 *
 * You can specify a `participantNotification.message` for the customer.
 * To send the message, you must also specify `participantNotification.notifyParticipants` as `true`.
 *
 * ### Admin overwrites
 *
 * There are small but important differences when you specify special
 * `flowControlSettings`:
 *
 * - `{"checkAvailabilityValidation": true}`: Checks for double booking conflicts before updating the status.
 * When conflicts exist, the booking is still marked as `PENDING` and `doubleBooked` is set to `true` for the business to resolve manually.
 * - `{"skipPendingApprovalServiceValidation": true}`: Allows marking any booking as pending, even if the service doesn't require manual approval.
 *
 * When using special `flowControlSettings`, ensure you have sufficient permissions.
 * If you encounter failed calls due to insufficient permissions, consider the following options:
 *
 * - __App developers__ can use a higher
 * [permission](https://dev.wix.com/docs/build-apps/develop-your-app/access/authorization/about-permissions), such as `MANAGE BOOKINGS - ALL PERMISSIONS`.
 * - __Site developers__ can utilize
 * [elevation](https://dev.wix.com/docs/develop-websites/articles/coding-with-velo/authorization/elevation).
 *
 * Granting additional permissions and using elevation permits method calls that would typically fail due to authorization checks.
 * Therefore, you should use them intentionally and securely.
 */
export function markBookingAsPending(payload) {
    var _a = serializer(_markBookingAsPendingRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_markBookingAsPendingResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _v2Booking: _v2Booking,
        _v2ContactDetails: _v2ContactDetails,
    }).fromJSON;
    function __markBookingAsPending(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.bookings.v2.Bookings.MarkBookingAsPending',
            url: resolveComWixpressBookingsBookingsV2BookingsUrl({
                protoPath: '/v2/bookings/{bookingId}/mark_booking_as_pending',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __markBookingAsPending.fromReq = fromReq;
    __markBookingAsPending.__isAmbassador = true;
    return __markBookingAsPending;
}
/** Returns the count of bookings based on the given filters. */
export function countBookings(payload) {
    var _a = serializer(_countBookingsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_countBookingsResponse, {}).fromJSON;
    function __countBookings(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.bookings.v2.Bookings.CountBookings',
            url: resolveComWixpressBookingsBookingsV2BookingsUrl({
                protoPath: '/v2/bookings/count',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __countBookings.fromReq = fromReq;
    __countBookings.__isAmbassador = true;
    return __countBookings;
}
/**
 * Creates a multi-service booking and all included single-service bookings simultaneously.
 *
 *
 * ### When to call this method
 *
 * Create sequential appointments where customers book related services together. For adding existing single-service bookings to an existing multi-service booking, call Add Bookings to Multi Service Booking ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/bookings-writer-v2/add-bookings-to-multi-service-booking) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/bookings/bookings-writer-v2/add-bookings-to-multi-service-booking)) instead.
 *
 * ### Requirements and behavior
 *
 * __Package constraints__: Multi-service bookings support 2-8 appointment-based single-service bookings only (course and class bookings aren't supported). All single-service bookings must be at the same location with sequential scheduling and no gaps between appointments.
 *
 * __Timing specification__: You must provide complete `slot` details (`scheduleId`, `startDate`, `endDate`) for each single-service booking. Wix Bookings validates sequential timing but doesn't auto-calculate it.
 *
 * __Package pricing__: The total price equals the sum of individual services. Wix Bookings automatically syncs the payment status from the corresponding Wix eCommerce order ([SDK](https://dev.wix.com/docs/sdk/backend-modules/ecommerce/orders/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/e-commerce/orders/introduction)) if the customer paid via an eCommerce checkout ([SDK](https://dev.wix.com/docs/sdk/backend-modules/ecom/checkout/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/e-commerce/checkout/introduction)).
 *
 * __Package notifications__: Customers receive 1 unified notification for the entire multi-service booking. Wix Bookings doesn't send notifications for the package's individual single-service bookings.
 *
 * ### Related methods
 *
 * Verify availability first with List Multi Service Availability Time Slots ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/time-slots/multi-service-availability-time-slots/list-multi-service-availability-time-slots) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/time-slots/time-slots-v2/list-multi-service-availability-time-slots)).
 *
 * See Create Booking ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/bookings/create-booking) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/bookings/bookings-writer-v2/create-booking)) for more details about constraints and effects of creating single-service bookings.
 */
export function createMultiServiceBooking(payload) {
    var _a = serializer(_createMultiServiceBookingRequest, { _address: _address, _addressLocation: _addressLocation, _v2Booking: _v2Booking, _v2ContactDetails: _v2ContactDetails }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createMultiServiceBookingResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _bookingResult: _bookingResult,
        _multiServiceBooking: _multiServiceBooking,
        _v2Booking: _v2Booking,
        _v2ContactDetails: _v2ContactDetails,
    }).fromJSON;
    function __createMultiServiceBooking(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.bookings.v2.MultiServiceBookings.CreateMultiServiceBooking',
            url: resolveComWixpressBookingsBookingsV2MultiServiceBookingsUrl({
                protoPath: '/v2/multi_service_bookings',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createMultiServiceBooking.fromReq = fromReq;
    __createMultiServiceBooking.__isAmbassador = true;
    return __createMultiServiceBooking;
}
/**
 * Reschedules a multi-service booking by changing the timing for all or specific single-service bookings in the package.
 *
 *
 * This method reschedules single-service bookings within the multi-service booking while maintaining sequential order. You must specify exact new timing for each service to ensure they remain back-to-back with no gaps or overlaps.
 *
 * This method fails if it can't reschedule at least 1 single-service booking. You must provide the current revision number for each single-service booking you're rescheduling to prevent conflicting changes.
 *
 * See Reschedule Booking ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/bookings/reschedule-booking) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/bookings/bookings-writer-v2/reschedule-booking)) for single-service booking rescheduling details.
 */
export function rescheduleMultiServiceBooking(payload) {
    var _a = serializer(_rescheduleMultiServiceBookingRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_rescheduleMultiServiceBookingResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _bookingResult: _bookingResult,
        _multiServiceBooking: _multiServiceBooking,
        _v2Booking: _v2Booking,
        _v2ContactDetails: _v2ContactDetails,
    }).fromJSON;
    function __rescheduleMultiServiceBooking(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.bookings.v2.MultiServiceBookings.RescheduleMultiServiceBooking',
            url: resolveComWixpressBookingsBookingsV2MultiServiceBookingsUrl({
                protoPath: '/v2/multi_service_bookings/{multiServiceBookingId}/reschedule',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __rescheduleMultiServiceBooking.fromReq = fromReq;
    __rescheduleMultiServiceBooking.__isAmbassador = true;
    return __rescheduleMultiServiceBooking;
}
/**
 * Checks if the business can still accommodate an existing multi-service booking and returns overall bookability status, capacity details, and policy violations.
 *
 *
 * Wix Bookings considers:
 * - The relevant services' booking policies ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/booking-policies/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/policies/booking-policies/introduction)).
 * - The availability of all required resources ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/resources/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/resources/resources-v2/introduction)).
 *
 * Call this method to check if an existing multi-service booking is still valid after business configuration changes.
 * For example, staff changes, policy updates, or capacity modifications.
 *
 * For checking availability before creating new multi-service bookings, call List Multi Service Availability Time Slots
 * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/time-slots/multi-service-availability-time-slots/list-multi-service-availability-time-slots) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/time-slots/time-slots-v2/list-multi-service-availability-time-slots)) instead.
 */
export function getMultiServiceBookingAvailability(payload) {
    var _a = serializer(_getMultiServiceBookingAvailabilityRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getMultiServiceBookingAvailabilityResponse, {}).fromJSON;
    function __getMultiServiceBookingAvailability(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.bookings.v2.MultiServiceBookings.GetMultiServiceBookingAvailability',
            url: resolveComWixpressBookingsBookingsV2MultiServiceBookingsUrl({
                protoPath: '/v2/multi_service_bookings/{multiServiceBookingId}/get_availability',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getMultiServiceBookingAvailability.fromReq = fromReq;
    __getMultiServiceBookingAvailability.__isAmbassador = true;
    return __getMultiServiceBookingAvailability;
}
/**
 * Cancels a multi-service booking and all its associated single-service bookings.
 *
 *
 * Cancels the entire multi-service booking, updating the status of all single-service bookings to `CANCELED`.
 * The call fails if all single-service bookings are already canceled or declined.
 *
 * See Cancel Booking ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/bookings/cancel-booking) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/bookings/bookings-writer-v2/cancel-booking)) for single-service booking cancellation details.
 */
export function cancelMultiServiceBooking(payload) {
    var _a = serializer(_cancelMultiServiceBookingRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_cancelMultiServiceBookingResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _bookingResult: _bookingResult,
        _multiServiceBooking: _multiServiceBooking,
        _v2Booking: _v2Booking,
        _v2ContactDetails: _v2ContactDetails,
    }).fromJSON;
    function __cancelMultiServiceBooking(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.bookings.v2.MultiServiceBookings.CancelMultiServiceBooking',
            url: resolveComWixpressBookingsBookingsV2MultiServiceBookingsUrl({
                protoPath: '/v2/multi_service_bookings/{multiServiceBookingId}/cancel',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __cancelMultiServiceBooking.fromReq = fromReq;
    __cancelMultiServiceBooking.__isAmbassador = true;
    return __cancelMultiServiceBooking;
}
/**
 * Updates the status for all single-service bookings in a multi-service booking to `PENDING`.
 *
 *
 * Call this method for multi-service bookings requiring manual business approval before confirmation.
 *
 * ### Status requirements
 *
 * - __Original status__: All single-service bookings must have `CREATED` status.
 * - __Target status__: All bookings move to `PENDING` together (all-or-nothing operation).
 *
 * ### Checkout restrictions
 *
 * Only call this method if the customer paid via a custom checkout. For Wix eCommerce checkouts,
 * Wix Bookings automatically manages the bookings' statuses based on payment processing.
 *
 * ### Additional updates
 *
 * - __Payment status__: Updates if you specify a new `markAsPendingBookingsInfo.paymentStatus`.
 * - __Customer notifications__: Send messages using `participantNotification`.
 * - __Revision control__: Requires current revision numbers for all single-service bookings.
 *
 * See Mark Booking as Pending ([SDK](https://dev.wix.com/docs/rest/business-solutions/bookings/bookings/bookings-writer-v2/mark-booking-as-pending) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/bookings/bookings-writer-v2/mark-booking-as-pending)) for more details about marking single-service bookings as pending.
 */
export function markMultiServiceBookingAsPending(payload) {
    var _a = serializer(_markMultiServiceBookingAsPendingRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_markMultiServiceBookingAsPendingResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _bookingResult: _bookingResult,
        _multiServiceBooking: _multiServiceBooking,
        _v2Booking: _v2Booking,
        _v2ContactDetails: _v2ContactDetails,
    }).fromJSON;
    function __markMultiServiceBookingAsPending(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.bookings.v2.MultiServiceBookings.MarkMultiServiceBookingAsPending',
            url: resolveComWixpressBookingsBookingsV2MultiServiceBookingsUrl({
                protoPath: '/v2/multi_service_bookings/{multiServiceBookingId}/mark_as_pending',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __markMultiServiceBookingAsPending.fromReq = fromReq;
    __markMultiServiceBookingAsPending.__isAmbassador = true;
    return __markMultiServiceBookingAsPending;
}
/**
 * Updates the status for all single-service bookings in a multi-service booking to `CONFIRMED`.
 *
 *
 * Call this method for multi-service bookings requiring manual business approval.
 *
 * ### Status requirements
 *
 * - __Original status__: All single-service bookings must have `PENDING`, `CREATED`, or `WAITING_LIST` status.
 * - __Target status__: All bookings move to `CONFIRMED` together (all-or-nothing operation).
 *
 * ### Checkout restrictions
 *
 * Only call this method if the customer paid via a custom checkout. For Wix eCommerce checkouts,
 * Wix Bookings automatically manages the bookings' statuses based on payment processing.
 *
 * ### Additional updates
 *
 * - __Payment status__: Updates if you specify a new `confirmBookingsInfo.paymentStatus`.
 * - __Customer notifications__: Send messages using `participantNotification`.
 * - __Revision control__: Requires current revision numbers for all single-service bookings.
 *
 * See Confirm Booking ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/bookings/confirm-booking) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/bookings/bookings-writer-v2/confirm-booking)) for more details about confirming single-service bookings.
 */
export function confirmMultiServiceBooking(payload) {
    var _a = serializer(_confirmMultiServiceBookingRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_confirmMultiServiceBookingResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _bookingResult: _bookingResult,
        _multiServiceBooking: _multiServiceBooking,
        _v2Booking: _v2Booking,
        _v2ContactDetails: _v2ContactDetails,
    }).fromJSON;
    function __confirmMultiServiceBooking(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.bookings.v2.MultiServiceBookings.ConfirmMultiServiceBooking',
            url: resolveComWixpressBookingsBookingsV2MultiServiceBookingsUrl({
                protoPath: '/v2/multi_service_bookings/{multiServiceBookingId}/confirm',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __confirmMultiServiceBooking.fromReq = fromReq;
    __confirmMultiServiceBooking.__isAmbassador = true;
    return __confirmMultiServiceBooking;
}
/**
 * Updates the status for all single-service bookings in a multi-service booking to `DECLINED`.
 *
 *
 * Call this method to reject multi-service bookings that can't be accommodated or don't meet business requirements.
 *
 * ### Status requirements
 *
 * - __Original status__: All single-service bookings must have `PENDING`, `CREATED`, or `WAITING_LIST` status.
 * - __Target status__: All bookings move to `DECLINED` together (all-or-nothing operation).
 *
 * ### Checkout restrictions
 *
 * Only call this method if the customer paid via a custom checkout. For Wix eCommerce checkouts,
 * Wix Bookings automatically manages the bookings' statuses based on payment processing.
 *
 * ### Additional updates
 *
 * - __Payment status__: Updates if you specify a new `declineBookingsInfo.paymentStatus`.
 * - __Customer notifications__: Send messages using `participantNotification`.
 * - __Revision control__: Requires current revision numbers for all single-service bookings.
 *
 * Refer to Decline Booking ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/bookings/decline-booking) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/bookings/bookings-writer-v2/decline-booking)) for more details about declining single-service bookings.
 */
export function declineMultiServiceBooking(payload) {
    var _a = serializer(_declineMultiServiceBookingRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_declineMultiServiceBookingResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _bookingResult: _bookingResult,
        _multiServiceBooking: _multiServiceBooking,
        _v2Booking: _v2Booking,
        _v2ContactDetails: _v2ContactDetails,
    }).fromJSON;
    function __declineMultiServiceBooking(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.bookings.v2.MultiServiceBookings.DeclineMultiServiceBooking',
            url: resolveComWixpressBookingsBookingsV2MultiServiceBookingsUrl({
                protoPath: '/v2/multi_service_bookings/{multiServiceBookingId}/decline',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __declineMultiServiceBooking.fromReq = fromReq;
    __declineMultiServiceBooking.__isAmbassador = true;
    return __declineMultiServiceBooking;
}
/**
 * Retrieves information about which actions the customer can perform for up to 50 multi-service bookings.
 *
 *
 * For each multi-service booking, the response indicates which actions are currently allowed:
 * - `cancel`: Whether the customer can cancel the multi-service booking.
 * - `reschedule`: Whether the customer can adjust the multi-service booking's timing.
 *
 * Bear the following considerations in mind when calling this method:
 *
 * __Real-time validation__: Wix Bookings calculates allowed actions based on current multi-service booking status, booking policies ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/booking-policies/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/policies/booking-policies/introduction)), and available resources ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/resources/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/resources/resources-v2/introduction)) at the time of the call.
 *
 * __Permission context__: Depending on the permissions of the calling [identity](https://dev.wix.com/build-apps/develop-your-app/about-identities), you may see different allowed actions for the same multi-service booking. For example, if the identity has permissions to read only part of the multi-service booking, the response indicates which single-service bookings the identity can read.
 *
 * __Status dependencies__: Allowed actions change as bookings progress through their lifecycle (`CREATED` → `PENDING` → `CONFIRMED`/`DECLINED` → `CANCELED`).
 * Bookings can skip `PENDING` and move directly from `CREATED` to `CONFIRMED`/`DECLINED` based on service configuration.
 */
export function bulkGetMultiServiceBookingAllowedActions(payload) {
    var _a = serializer(_bulkGetMultiServiceBookingAllowedActionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkGetMultiServiceBookingAllowedActionsResponse, {}).fromJSON;
    function __bulkGetMultiServiceBookingAllowedActions(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.bookings.v2.MultiServiceBookings.BulkGetMultiServiceBookingAllowedActions',
            url: resolveComWixpressBookingsBookingsV2MultiServiceBookingsUrl({
                protoPath: '/v2/bulk/multi_service_bookings/get_allowed_actions',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkGetMultiServiceBookingAllowedActions.fromReq = fromReq;
    __bulkGetMultiServiceBookingAllowedActions.__isAmbassador = true;
    return __bulkGetMultiServiceBookingAllowedActions;
}
/**
 * Retrieves a multi-service booking and all its associated single-service bookings.
 *
 *
 * Returns the complete multi-service booking information including its ID, associated single-service bookings, and the total number of scheduled single-service bookings.
 *
 * If you call on behalf of an [identity](https://dev.wix.com/docs/build-apps/develop-your-app/access/about-identities) with permissions to read only part of the multi-service booking, only the permitted single-service bookings are retrieved.
 * The returned total number includes single-service bookings for which you don't have permissions.
 *
 * See Query Extended Bookings ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/extended-bookings/query-extended-bookings) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/bookings/bookings-reader-v2/query-extended-bookings)) for details about retrieving individual single-service bookings and additional metadata.
 */
export function getMultiServiceBooking(payload) {
    var _a = serializer(_getMultiServiceBookingRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getMultiServiceBookingResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _bookingResult: _bookingResult,
        _multiServiceBooking: _multiServiceBooking,
        _v2Booking: _v2Booking,
        _v2ContactDetails: _v2ContactDetails,
    }).fromJSON;
    function __getMultiServiceBooking(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'GET',
            methodFqn: 'com.wixpress.bookings.bookings.v2.MultiServiceBookings.GetMultiServiceBooking',
            url: resolveComWixpressBookingsBookingsV2MultiServiceBookingsUrl({
                protoPath: '/v2/multi_service_bookings/{multiServiceBookingId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getMultiServiceBooking.fromReq = fromReq;
    __getMultiServiceBooking.__isAmbassador = true;
    return __getMultiServiceBooking;
}
/**
 * Expands an existing multi-service booking by adding existing single-service bookings to the package.
 *
 *
 * ### When to call this method
 *
 * Call this method to add 1 or more existing single-service bookings to an existing multi-service booking.
 * For creating a new multi-service booking with new single-service bookings, call Create Multi Service Booking ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/bookings/create-multi-service-booking) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/bookings/bookings-writer-v2/create-multi-service-booking)) instead.
 *
 * ### Package integration
 *
 * The timing of the single-service bookings to add must be compatible with the multi-service booking's sequential schedule to ensure no gaps or overlaps between services in the updated package.
 *
 * ### Requirements and limitations
 *
 * - __Maximum capacity__: The total number of single-service bookings can't exceed 8.
 * - __Booking eligibility__: You can add only independent single-service bookings that aren't part of another multi-service booking.
 * - __Status compatibility__: Added bookings must have compatible status with the target multi-service booking.
 * - __Revision control__: You must provide current revision numbers for all single-service bookings to add.
 */
export function addBookingsToMultiServiceBooking(payload) {
    var _a = serializer(_addBookingsToMultiServiceBookingRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_addBookingsToMultiServiceBookingResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _bookingResult: _bookingResult,
        _v2Booking: _v2Booking,
        _v2ContactDetails: _v2ContactDetails,
    }).fromJSON;
    function __addBookingsToMultiServiceBooking(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.bookings.v2.MultiServiceBookings.AddBookingsToMultiServiceBooking',
            url: resolveComWixpressBookingsBookingsV2MultiServiceBookingsUrl({
                protoPath: '/v2/multi_service_bookings/add_bookings_to_multi_service_booking',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __addBookingsToMultiServiceBooking.fromReq = fromReq;
    __addBookingsToMultiServiceBooking.__isAmbassador = true;
    return __addBookingsToMultiServiceBooking;
}
/**
 * Removes single-service bookings from a multi-service booking and converts them to independent single-service bookings.
 *
 *
 * ### Removal options
 *
 * __Remove all permitted bookings__: If you specify an empty `bookings` array, all single-service bookings for which the call's [identity](https://dev.wix.com/docs/build-apps/develop-your-app/access/about-identities) has read permissions are removed from the multi-service booking.
 *
 * __Selective removal__: Specify single-service booking IDs and revisions to remove only specific single-service bookings from the package.
 *
 * __Sequential scheduling__: To maintain sequential scheduling, remove only first or last single-service bookings. For middle bookings, first reschedule all relevant single-service bookings to eliminate gaps. To do so, call Reschedule Multi Service Booking ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/bookings/reschedule-multi-service-booking) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/bookings/bookings-writer-v2/reschedule-multi-service-booking)) before removing the unwanted bookings.
 *
 * ### Removal behavior
 *
 * __Independent bookings__: Removed single-service bookings become independent bookings.
 * You can manage them using single-service booking methods.
 *
 * __Automatic cleanup__: Multi-service bookings must contain at least 2 services.
 * If removal results in only 1 remaining single-service booking for the multi-service booking, the entire multi-service booking is deleted and the remaining single-service booking becomes a standalone booking.
 *
 * __Revision control__: Specify current revision numbers to prevent conflicting modifications during the removal process.
 */
export function removeBookingsFromMultiServiceBooking(payload) {
    var _a = serializer(_removeBookingsFromMultiServiceBookingRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_removeBookingsFromMultiServiceBookingResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _bookingResult: _bookingResult,
        _v2Booking: _v2Booking,
        _v2ContactDetails: _v2ContactDetails,
    }).fromJSON;
    function __removeBookingsFromMultiServiceBooking(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v2.booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.bookings.v2.MultiServiceBookings.RemoveBookingsFromMultiServiceBooking',
            url: resolveComWixpressBookingsBookingsV2MultiServiceBookingsUrl({
                protoPath: '/v2/multi_service_bookings/remove_bookings_from_multi_service_booking',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __removeBookingsFromMultiServiceBooking.fromReq = fromReq;
    __removeBookingsFromMultiServiceBooking.__isAmbassador = true;
    return __removeBookingsFromMultiServiceBooking;
}
//# sourceMappingURL=http.impl.js.map